import { useQuery } from "react-query";
import api from "../services/api";

interface TeamFormData {
  matchId: number;
  matchday: number;
  result: "W" | "L" | "D";
  isHome: boolean;
  teamScore: number;
  opponentScore: number;
  kickoffTime: string;
}

interface TeamFormResponse {
  teamId: number;
  form: TeamFormData[];
  count: number;
}

export const useTeamForm = (teamId: number) => {
  return useQuery<TeamFormResponse>(
    ["teamForm", teamId],
    async () => {
      const response = await api.get(`/api/matches/team-form/${teamId}`);
      return response.data;
    },
    {
      enabled: !!teamId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );
};
